module.exports = __webpack_public_path__ + "media/images/ohap_my apps_share_blue-4bd1a0c090c6434cab5297a5824380ef.png";